import { NumberFormatUtils } from "./NumberFormatUtils";

declare global {
  interface Number {
    format(formatter: Intl.NumberFormat): string;
  }
}

// Implementation
if (!Number.prototype.format) {
  Number.prototype.format = function (formatter: Intl.NumberFormat): string {
    return NumberFormatUtils.format(this as number | null, formatter);
  };
}
